import { SearchState } from '@reducers/search';
import { getStartingIndex, ItemsState } from '@reducers/items';
import type { RankedItem } from '@shared/helpers/Rank/store';

const getRankFor = (
  urn: string,
  targetKind: 'GalleryItem' | 'AdItem' | 'GeoboostItem',
  search: SearchState,
  items: ItemsState
): number => {
  const start = getStartingIndex(search) ?? 0;
  const index = items.rankedList.findIndex(
    (listAd: RankedItem) => listAd.urn === urn && listAd.kind === targetKind
  );
  return Number(start) + Number(index);
};

export { getRankFor };
